import type { PagedResultDto } from "@services/dto/pagedResultDto"
import inquiryService from "@services/projects/inquiryService"
import { action, makeAutoObservable, observable } from "mobx"

class InquiryStore {
  @observable isLoading = false
  @observable pageResult: PagedResultDto<any>
  @observable bookings: PagedResultDto<any>
  @observable contracts: PagedResultDto<any>
  @observable inquiryDetail!: any

  @observable auditLogResult: any
  @observable matchingInquiry: PagedResultDto<any>
  @observable listInquirySimple: Array<any> = []

  constructor() {
    makeAutoObservable(this)
    this.pageResult = { totalCount: 0, items: [] }
    this.bookings = { totalCount: 0, items: [] }
    this.contracts = { totalCount: 0, items: [] }
    this.matchingInquiry = { totalCount: 0, items: [] }
    this.inquiryDetail = {}
  }

  @action getAll = async (params) => {
    this.isLoading = true
    this.pageResult = await inquiryService
      .getAll(params)
      .finally(() => (this.isLoading = false))
  }
  @action getListBookingById = async (params) => {
    this.isLoading = true
    this.bookings = await inquiryService
      .getListBookingById(params)
      .finally(() => (this.isLoading = false))
  }

  @action getListContractById = async (params) => {
    this.isLoading = true
    this.contracts = await inquiryService
      .getListContractById(params)
      .finally(() => (this.isLoading = false))
  }

  @action getAuditLogs = async (params) => {
    this.isLoading = true
    this.auditLogResult = await inquiryService
      .getAuditLogs(params)
      .finally(() => (this.isLoading = false))
  }
  @action
  async createOrUpdate(body) {
    this.isLoading = true

    const result = await inquiryService
      .createOrUpdate({ ...body })
      .finally(() => (this.isLoading = false))

    this.inquiryDetail = result
    return result
  }

  @action
  async UpdateComplete(id) {
    await inquiryService.UpdateComplete(id)
  }

  @action
  async convertToBooking(inquiryId: number) {
    this.isLoading = true
    const result = await inquiryService
      .convertToBooking(inquiryId)
      .finally(() => (this.isLoading = false))
    return result
  }
  @action
  async UpdateDrop(params) {
    await inquiryService.UpdateDrop(params)
  }

  @action
  async initDetail() {
    this.inquiryDetail = {}
  }

  @action async get(id) {
    this.isLoading = true
    const result = await inquiryService
      .get(id)
      .finally(() => (this.isLoading = false))
    this.inquiryDetail = result
  }

  @action async getMatchingInquiry(params) {
    this.isLoading = true
    this.matchingInquiry = await inquiryService
      .getMatchingInquiry(params)
      .finally(() => (this.isLoading = false))
  }
  @action
  async activateOrDeactivate(id: number, isActive) {
    await inquiryService.activateOrDeactivate(id, isActive)
  }
  @action
  async addToListSimpleInquiry(value) {
    this.listInquirySimple = [...this.listInquirySimple, { ...value }]
  }
  @action
  async getSimpleInquiry(params) {
    this.isLoading = true

    const res = await inquiryService
      .getSimpleInquiry(params)
      .finally(() => (this.isLoading = false))
    this.listInquirySimple = res
  }
  @action async getDueDate(params) {
    const res = await inquiryService.getDueDate(params)
    return res
  }
}

export default InquiryStore
